
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('InvestmentSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let Investment = Parse.Object.extend('Investments');

		// Define 'Investment' scheme
		let schema = [
			'User',
			'Project',
			'amount',
			'status',
			'pledge_reward',
			'pledge_reward_options',
			'stripe_charge_id',
			'receipt_url'
		];

		// Load schema into object prototype
		schema.forEach(function (field) {
			Object.defineProperty(Investment.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});
    
    return Investment;
		
	});
}


// WEBPACK FOOTER //
// ./src/app/core/schemas/investment.schema.js